module.exports = __webpack_public_path__ + "img/img-9.077b3de1.png";